import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";

import {
    selectUsuarioSeleccionado,
} from "../../../redux/reducer/loginReducer";
import { useSelector } from 'react-redux';
import AlumnosEnviosPostalesContent from './components/AlumnosEnviosPostalesContent';

const AlumnosEnviosPostalesListado = () => {
    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    return (
        <>

            <TemplateDashboard>
                { 
                    <AlumnosEnviosPostalesContent />
                }
            </TemplateDashboard>

        </>
    )
};

export default AlumnosEnviosPostalesListado;